export default __webpack_public_path__ + "static/media/EAST0002.34I-35167_-20420_0.c3c804ab.jpg";